var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSectionFacebookBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 1.18188H6.12154C5.21739 1.18188 4.35027 1.54106 3.71095 2.18038C3.07162 2.81971 2.71245 3.68683 2.71245 4.59098V6.63643H0.666992V9.3637H2.71245V14.8182H5.43972V9.3637H7.48517L8.16699 6.63643H5.43972V4.59098C5.43972 4.41015 5.51155 4.23672 5.63942 4.10886C5.76729 3.98099 5.94071 3.90916 6.12154 3.90916H8.16699V1.18188Z",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSectionFacebookBgBlack);
export default __webpack_public_path__ + "static/media/footer_section_facebook_bg_black.a025be134da0d34fb38d42330c17b14e.svg";
export { ForwardRef as ReactComponent };